<template>
    <div>
        <el-card>
            <div class="boxClass">
                <span>细化发布</span>
                <div>
                    <router-link :to="{ path: '/publishStatusList'}">
                        <span>发布RFC状态实时汇总</span>
                    </router-link>
                    <router-link :to="{ path: '/publishStatusStatis'}">
                        <span>发布状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/groupePublishStatus'}">
                        <span>组别发布状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/publishRFCNum'}">
                        <span>发布RFC数量</span>
                    </router-link>
                    <router-link :to="{ path: '/publishRFCNumStatus'}">
                        <span>发布RFC数量状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/publishRFCNumGroupe'}">
                        <span>发布RFC数量组别状态统计</span>
                    </router-link>
                     <router-link :to="{ path: '/publishRFCCloseNum'}">
                        <span>发布RFC的关闭数量</span>
                    </router-link>
                    <router-link :to="{ path: '/publishRFCCloseNumStatus'}">
                        <span>发布RFC关闭数量状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/publishRFCCloseNumGroupe'}">
                        <span>发布RFC关闭数量组别统计</span>
                    </router-link>
                </div>
                
            </div>
        </el-card>
    </div>
</template>

<script>
    
    export default {
        
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .boxClass{
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        &>span{
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
        }
        &>div{
            display: flex;
            flex-wrap:wrap;
            span{
                color:gray!important;
                margin-right: 30px;
            }
        }
    }
</style>